<template>
  <div>
    <div v-if="is_h5 == false" class="index-pc-root">
      <el-scrollbar wrap-style="overflow-x:hidden;">
        <pheader activeIndex="Index"></pheader>
        <div class="pc_index-banner">
          <div class="pc_index-banner__inner">
            <div class="pc_index-banner__frame">
              <div class="pc_index-banner__media">
                <el-image
                  class="pc_index-banner__img"
                  :src="bannerImages[0]"
                  fit="cover"
                />
              </div>
            </div>
          </div>
        </div>
        <el-container class="pc_index_main">
          <el-main v-loading="pageLoading" class="index-pc-main" element-loading-text="加载中…">
            <el-empty
              v-if="!pageLoading && indexDataLoaded && items.length === 0"
              class="index-global-empty"
              description="暂无首页推荐数据，请稍后再试"
            />
            <el-row v-for="(item, idx) in items" :key="idx">
              <el-col :span="24">
                <div v-if="item.items && item.items.length > 0" :class="'pc_index_main-' + idx % 2">
                  <div class="pc_index-content ibp-major-content-shell">
                    <div class="pc_index-section-head">
                      <div class="pc_index-section-head-row">
                        <h3 class="pc_index-section-name">{{ item.dict_name }}</h3>
                        <template v-if="isShowChildTypeNodes">
                          <div class="pc_index-tabs-inline">
                            <div class="pc_index-tabs-toolbar-inner">
                              <el-tabs
                                v-model="activeTabs[item.dict_name]"
                                class="index-sub-tabs index-sub-tabs--flex"
                                @tab-click="handleTablsClick($event, idx)"
                              >
                                <el-tab-pane :key="item.dict_name" label="全部" :name="item.dict_name"></el-tab-pane>
                                <el-tab-pane
                                  v-for="tabInfo in item.children"
                                  :key="tabInfo._id"
                                  :label="tabInfo.dict_name"
                                  :name="item.dict_name + '/' + tabInfo.dict_name"
                                ></el-tab-pane>
                              </el-tabs>
                              <el-button
                                class="pc_index-more-btn pc_index-more-btn--inbar"
                                type="primary"
                                plain
                                round
                                @click="handleMore('Home', item)"
                              >
                                更多
                                <el-icon class="pc_index-more-ico"><ArrowRight /></el-icon>
                              </el-button>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="pc_index-section-head-spacer" aria-hidden="true" />
                          <el-button
                            class="pc_index-more-btn"
                            type="primary"
                            plain
                            round
                            @click="handleMore('Home', item)"
                          >
                            更多
                            <el-icon class="pc_index-more-ico"><ArrowRight /></el-icon>
                          </el-button>
                        </template>
                      </div>
                    </div>
                    <div
                      class="pc_index-grid-wrap"
                      v-loading="!!loadingList[idx]"
                      element-loading-text="加载中…"
                      element-loading-background="rgba(255,255,255,0.72)"
                    >
                      <el-row
                        v-if="activeTabs[item.dict_name] == item.dict_name"
                        :gutter="20"
                        style="width: 100%;"
                      >
                        <el-col :span="spanValue" class="col" v-for="(cItem, cIdx) in item.items" :key="cIdx" :label="cIdx">
                          <div class="xbox" @click="toggleMediaDisplay(cItem)">
                            <div style="height: calc(100% * 2/3);">
                              <el-image style="height: 100%; width: 100%; border-radius: 10px 10px 0px 0px;" :src="getImageSource(cItem.cover_image)" fit="contain" ref="imageRef">
                              </el-image>
                            </div>
                            <div class="text" style="height: calc(100% * 1/3); background-color: white; min-height: 80px; border-radius: 0px 0px 10px 10px;">
                              <div class="title">{{ cItem.name}}</div>
                              <div class="source">
                                <div>{{ ' ' + (cItem.orgname.split('/')[cItem.orgname.split('/').length -1] || cItem.sys_org_name && cItem.sys_org_name.split('/')[0]) }}</div>
                              </div>
                              <div>
                                <span style="float: left;"><el-icon><User /></el-icon>{{ ' ' + (cItem.username || cItem.sys_username) }}</span>
                                <span style="float: right;"><el-icon><View /></el-icon>{{' ' + (cItem.read_count || 0)}}</span>
                              </div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                      <template v-else>
                        <el-row
                          v-if="(activeTabsChildrenItems[activeTabs[item.dict_name].replace('/', '_')] || []).length"
                          :gutter="20"
                          style="width: 100%;"
                        >
                          <el-col :span="spanValue" class="col" v-for="(cItem, cIdx) in activeTabsChildrenItems[activeTabs[item.dict_name].replace('/', '_')]" :key="cIdx" :label="cIdx">
                            <div class="xbox" @click="toggleMediaDisplay(cItem)">
                              <div style="height: calc(100% * 2/3);">
                                <el-image style="height: 100%; width: 100%; border-radius: 10px 10px 0px 0px;" :src="getImageSource(cItem.cover_image)" fit="contain" ref="imageRef">
                                </el-image>
                              </div>
                              <div class="text" style="height: calc(100% * 1/3); background-color: white; min-height: 80px; border-radius: 0px 0px 10px 10px;">
                                <div class="title">{{ cItem.name}}</div>
                                <div class="source">
                                  <div>{{ ' ' + (cItem.orgname.split('/')[cItem.orgname.split('/').length -1] || cItem.sys_org_name && cItem.sys_org_name.split('/')[0]) }}</div>
                                </div>
                                <div>
                                  <span style="float: left;"><el-icon><User /></el-icon>{{ ' ' + (cItem.username || cItem.sys_username) }}</span>
                                  <span style="float: right;"><el-icon><Pointer /></el-icon>{{' ' + (cItem.read_count || 0)}}</span>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                        <el-empty
                          v-else-if="!loadingList[idx]"
                          class="pc_index-sub-empty"
                          description="该子分类下暂无课程"
                        />
                      </template>
                    </div>
                  </div>
                </div>
                <div v-else :class="'pc_index_main-' + idx % 2">
                  <div class="pc_index-content ibp-major-content-shell pc_index-empty-section">
                    <div class="pc_index-section-head">
                      <div class="pc_index-section-head-row">
                        <h3 class="pc_index-section-name">{{ item.dict_name }}</h3>
                        <div class="pc_index-section-head-spacer" aria-hidden="true" />
                        <el-button
                          class="pc_index-more-btn"
                          type="primary"
                          plain
                          round
                          @click="handleMore('Home', item)"
                        >
                          更多
                          <el-icon class="pc_index-more-ico"><ArrowRight /></el-icon>
                        </el-button>
                      </div>
                    </div>
                    <el-empty description="该分类下暂无课程资源" />
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
        <pfooter></pfooter>
      </el-scrollbar>
    </div>
    <div v-else>
      <pheader activeIndex="Index"></pheader>
      <div v-loading="pageLoading" class="h5-index-body" element-loading-text="加载中…">
        <van-row>
          <van-col span="24">
            <van-swipe :autoplay="3000" lazy-render>
              <van-swipe-item v-for="image in bannerImages" :key="image">
                <img style="height: 150px; width: 100%;" :src="image" />
              </van-swipe-item>
            </van-swipe>
          </van-col>
        </van-row>
        <van-empty v-if="!pageLoading && indexDataLoaded && items.length === 0" description="暂无首页推荐数据" />
        <van-row v-for="(item, idx) in items" :key="idx">
          <van-col span="24" v-if="item.items && item.items.length > 0">
            <div :class="'pc_index_main-' + idx%2">
              <div class="h5_index-content">
                <div class="h5_index-item-title">
                  <span class="h5_index-section-name">{{ item.dict_name }}</span>
                  <van-button
                    class="h5_index-more-btn"
                    type="primary"
                    size="small"
                    plain
                    hairline
                    round
                    @click="handleMore('Home', item)"
                  >
                    更多
                    <van-icon name="arrow" class="h5_index-more-ico" />
                  </van-button>
                </div>
                <div>
                  <van-list>
                    <van-grid :border="false" :column-num="2" :gutter="4" :clickable="true" style="width: 100%;">
                      <van-grid-item v-for='(cItem, cIdx) in item.items' :key="cIdx" :label="cIdx" @click="toggleMediaDisplay(cItem)">
                        <van-image
                          :src="getImageSource(cItem.cover_image)"
                        />
                        <div style="width: 100%;font-size: 14px; text-align: left;">
                          <div class="van-multi-ellipsis--l2" >
                            {{ cItem.name}}
                          </div>
                          <div style="margin-top: 10px; font-size: 10px; color: #969799;">
                            <span style="float: left;"><van-icon name="user-o" />{{ ' ' + (cItem.orgname.split('/')[cItem.orgname.split('/').length -1] || cItem.sys_org_name && cItem.sys_org_name.split('/')[0]) }} / {{ ' ' + (cItem.username || cItem.sys_username) }}</span>
                            <span style="float: right;"><van-icon name="play-circle-o" />{{' ' + (cItem.read_count || 0)}}</span>
                          </div>
                        </div>
                      </van-grid-item>
                    </van-grid>
                  </van-list>
                </div>
              </div>
            </div>
          </van-col>
          <van-col v-else span="24">
            <div class="h5_index-content h5_index-empty-block">
              <div class="h5_index-item-title">
                <span class="h5_index-section-name">{{ item.dict_name }}</span>
                <van-button
                  class="h5_index-more-btn"
                  type="primary"
                  size="small"
                  plain
                  hairline
                  round
                  @click="handleMore('Home', item)"
                >
                  更多
                  <van-icon name="arrow" class="h5_index-more-ico" />
                </van-button>
              </div>
              <van-empty description="该分类下暂无课程" />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <ai-search-component :isisShow="isisShow"></ai-search-component>
    <div
      class="ibp-h5-ai-fab"
      role="button"
      tabindex="0"
      aria-label="打开课程助手"
      @click="clickAIButton($event)"
      @keydown.enter.prevent="clickAIButton($event)"
    >
      <div class="ibp-h5-ai-fab__inner">
        <el-image class="ibp-h5-ai-fab__img" fit="contain" :src="require('@/assets/hcvt.png')" />
        <p class="ibp-h5-ai-fab__label">课程助手</p>
      </div>
    </div>
  </div>
</template>

<script>
import {showNotify} from 'vant';
import { ref } from 'vue';
import pheader from "@/views/pheader.vue";
import pfooter from "@/views/pfooter.vue";
import aiSearchComponent from "@/components/ai-search-component.vue";


export default {
  name: 'searchDetail',
  components: {
    pheader,
    pfooter,
    aiSearchComponent,
  },
  props: {

  },
  setup() {
    const loading_h5 = ref(false);
    const apiUrls = {
      'getIndexDataByParent':'/onlineCodeService/jxzysjfl_api/getIndexDataByParent',
      'getIndexDataByIncludeClass':'/onlineCodeService/jxzysjfl_api/getIndexDataByIncludeClass',
    };
    return {
      loading_h5,
      apiUrls
    };
  },
  data(){
    return {
      bannerImages:[
        require('@/assets/imgs/banner-1-1400-wz.jpg'),
        require('@/assets/imgs/8089b85eb69cc73cd4c55b860766957b.jpg')
      ],
      is_h5: this.$utils.checkScreenSize(),
      title:'',
      items:[],
      spanValue:4,
      PageSize: 10,
      activeTabs: {},
      activeTabsChildrenItems: {},
      isisShow:0,
      isShowChildTypeNodes: true,
      loadingList: [],
      /** 首页首屏数据加载（避免布局跳动） */
      pageLoading: false,
      indexDataLoaded: false,
    }
  },
  created() {

  },
  methods:{
    clickAIButton(){
      this.isisShow +=1
    },
    /** 节点 dict_code / value / id，与课程中心 dictFieldKey 一致 */
    nodeDictCode(node) {
      if (!node) return ''
      if (node.dict_code != null && String(node.dict_code).length) return String(node.dict_code)
      if (node.value != null && String(node.value).length) return String(node.value)
      if (node.id != null) return String(node.id)
      return ''
    },
    /** 当前 Tab 为「父名/子名」时解析子节点 dict_code */
    activeChildDictCode(sectionItem, activeTabName) {
      if (!sectionItem || !activeTabName) return ''
      if (activeTabName === sectionItem.dict_name) return ''
      const parts = String(activeTabName).split('/')
      if (parts.length < 2) return ''
      const childLabel = parts[parts.length - 1]
      const child = (sectionItem.children || []).find(
        (c) => (c.dict_name || c.label) === childLabel
      )
      return child ? this.nodeDictCode(child) : ''
    },
    /**
     * 进入课程中心：?l1=一级字段 dict_code；若在首页选了子类 Tab，再带 ?l2=子类 dict_code。
     */
    handleMore(key, sectionItem) {
      const path = '/' + key
      const query = {}
      if (sectionItem) {
        const l1 = this.nodeDictCode(sectionItem)
        if (l1) query.l1 = l1
        const active =
          sectionItem.dict_name != null ? this.activeTabs[sectionItem.dict_name] : null
        const l2 = this.activeChildDictCode(sectionItem, active)
        if (l2) query.l2 = l2
      }
      const routeUrl = this.$router.resolve(
        Object.keys(query).length ? { path, query } : { path }
      )
      window.location.href = routeUrl.href
    },
    windowResize(){
      this.spanValue = this.$utils.calculateSpan()
      this.PageSize = 24 / this.spanValue * 2 / 2
      console.log('windowResize', this.spanValue, this.PageSize)

      if (this.is_h5){
        this.PageSize = 2
      }
      this.initPageSize();
    },
    initPageSize(){
      if (this.PageSize < 0){
        this.PageSize = 10
      }
      this.init()
    },
    init(){
      this.loadIndexData()  
    },
    loadIndexData() {
      this.pageLoading = true
      this.indexDataLoaded = false
      let param = {'count': this.PageSize}
      this.$http.post(this.apiUrls.getIndexDataByParent, param).then(res => {
        this.pageLoading = false
        this.indexDataLoaded = true
        if ('0' == res.resultCode) {
          this.items = Array.isArray(res.resultData) ? res.resultData : []
          this.activeTabs = {}
          this.loadingList = this.items.map(() => false)
          this.items.forEach((obj) => {
            this.activeTabs[obj.dict_name] = obj.dict_name
          })
        } else {
          this.items = []
          this.loadingList = []
          window.vueAlter(res.resultMsg, 'warning')
        }
      }).catch(error => {
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
        this.items = []
        this.loadingList = []
        this.pageLoading = false
        this.indexDataLoaded = true
      })
    },
    toggleMediaDisplay(obj){
      let routeUrl = this.$router.resolve({
        path: "/Detail",
        query: {
          _id:obj._id, 
          title:obj.name
        }
      });
      if (this.is_h5){
        if (obj.open_method == '直接跳转'){
          window.location.href = this.$utils.buildCourseSsoUrl(obj.kc_url, obj.kc_source)
          return false;
        }
        window.location.href = routeUrl.href
      }else{
        if (obj.open_method == '直接跳转'){
          window.open(this.$utils.buildCourseSsoUrl(obj.kc_url, obj.kc_source), '_blank');
          return false;
        }
        this.$utils.windowOpen(routeUrl.href)
      }
    },
    getImageSource(img){
      if (undefined != img && !img.startsWith("http")){
        return this.$utils.getImageSource(img)
      }else{
        return img
      }
    },
    handleTablsClick(tab,idx){
      var _name = tab.props.name
      if (this.activeTabsChildrenItems[_name.replace("/", "_")] && this.activeTabsChildrenItems[_name.replace("/", "_")].length > 0){
        console.log()
      }else{
        if (this.loadingList[idx] !== undefined) {
          this.loadingList[idx] = true
        }
        let param = {'count': this.PageSize, 'name': _name}
        this.$http.post(this.apiUrls.getIndexDataByIncludeClass, param).then(res => {
          if (this.loadingList[idx] !== undefined) {
            this.loadingList[idx] = false
          }
          if ('0' == res.resultCode) {
            console.log(_name.split("/")[0])
            this.activeTabsChildrenItems[_name.replace("/", "_")] = res.resultData
          } else {
            this.activeTabsChildrenItems[_name.replace("/", "_")] = []
            window.vueAlter(res.resultMsg, 'warning')
          }
        }).catch(error => {
          showNotify('请求失败，请稍后再试！')
          console.log(error)
          console.log('失败')
          this.activeTabsChildrenItems[_name.replace("/", "_")] = []
          if (this.loadingList[idx] !== undefined) {
            this.loadingList[idx] = false
          }
        })
      }
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.windowResize();
    })
    // 添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.windowResize);
  },
  watch: {
    
  }

};
</script>
<style scoped>
/* 与 home / 专业课程主区一致：字体栈 + 浅蓝渐变底（变量供横幅与主区共用，避免 banner 顶上一块发白） */
.index-pc-root {
  --major-page-bg: #e8f1fb;
  --major-page-bg-mid: #eef4fb;
  --major-page-bg-soft: #f4f8fc;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', system-ui, -apple-system,
    'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* 上接横幅底 #eef4fb，整页呈连续浅蓝渐变 */
.index-pc-main {
  background: linear-gradient(
    180deg,
    var(--major-page-bg-mid) 0%,
    var(--major-page-bg) 32%,
    var(--major-page-bg-soft) 100%
  );
  padding-bottom: 40px;
}

/* 与主区同色阶；顶边贴 header，主视觉自上而下更连贯 */
.pc_index-banner {
  padding: 0 0 clamp(16px, 2.5vw, 28px);
  background: linear-gradient(
    180deg,
    var(--major-page-bg) 0%,
    var(--major-page-bg-mid) 100%
  );
}

.pc_index-banner__inner {
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  padding: 0 var(--ibp-major-content-padding-x, 5px);
  box-sizing: border-box;
}

.pc_index-banner__frame {
  position: relative;
  /* 仅底部圆角：上沿与顶栏齐平，避免「悬空一条」 */
  border-radius: 0 0 clamp(14px, 1.6vw, 22px) clamp(14px, 1.6vw, 22px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-top: none;
  /* 阴影主要落在下方，顶边干净贴顶 */
  box-shadow: 0 10px 28px rgba(23, 92, 196, 0.11);
}

.pc_index-banner__media {
  height: clamp(220px, 28vw, 360px);
  width: 100%;
  /* 加载前纯色底，避免渐变底像发虚 */
  background: var(--major-page-bg-mid);
}

.pc_index-banner__img {
  display: block;
  width: 100%;
  height: 100%;
}

.pc_index-banner :deep(.pc_index-banner__img.el-image),
.pc_index-banner :deep(.pc_index-banner__img .el-image__wrapper) {
  width: 100%;
  height: 100%;
  background-color: transparent !important;
}

.pc_index-banner :deep(.pc_index-banner__img .el-image__inner) {
  object-position: center center;
}

@media screen and (max-width: 1400px) {
  .pc_index-banner__inner {
    max-width: 100%;
    padding-left: var(--ibp-major-content-narrow-padding-x, 14px);
    padding-right: var(--ibp-major-content-narrow-padding-x, 14px);
  }
}

.pc_index_main-0,
.pc_index_main-1 {
  margin-top: 0;
  background-color: transparent;
}

/* 宽度与左右留白由 global .ibp-major-content-shell 统一控制；纵向收紧，一级之间约一行卡片间距 */
.pc_index-content {
  padding-top: 8px;
  padding-bottom: 8px;
}

.pc_index-content .col{
  padding-bottom:20px;
}

.pc_index-content .xbox {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(23, 92, 196, 0.08);
  box-shadow: 0 4px 20px rgba(23, 92, 196, 0.06);
  cursor: pointer;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.pc_index-content .xbox:hover {
  border-color: rgba(23, 92, 196, 0.18);
  box-shadow: 0 10px 36px rgba(23, 92, 196, 0.12);
  transform: translateY(-2px);
}

.pc_index-content .xbox .text {
  padding: 16px 14px 18px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.45;
}

.pc_index-content .xbox .title {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pc_index-content .xbox .source {
  margin: 8px 0 12px;
  font-size: 12px;
  color: #94a3b8;
}

.pc_index-content .xbox .text .el-icon {
  vertical-align: -2px;
  color: #94a3b8;
}

.pc_text-content {
    color: #969799;
    padding-left: 20px;
    padding-right: 20px;
}

.pc_index-section-head {
  margin-bottom: 8px;
}

.pc_index-section-head-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  min-height: 40px;
  width: 100%;
}

.pc_index-section-head-spacer {
  flex: 1;
  min-width: 0;
}

.pc_index-tabs-toolbar-inner {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 4px;
}

.index-sub-tabs--flex {
  flex: 1;
  min-width: 0;
}

.pc_index-section-name {
  flex-shrink: 0;
  margin: 0;
  max-width: 200px;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 0.02em;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pc_index-tabs-inline {
  flex: 1;
  min-width: 0;
  /* 右侧贴内边，避免「更多」与白底条右缘留缝 */
  padding: 2px 0 2px 6px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(23, 92, 196, 0.12);
  border-radius: 10px;
  box-shadow: 0 1px 8px rgba(23, 92, 196, 0.06);
}

.pc_index-more-btn {
  flex-shrink: 0;
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  padding: 6px 14px !important;
  margin-right: 0 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  border-color: rgba(23, 92, 196, 0.45) !important;
  color: #175cc4 !important;
  background: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 1px 6px rgba(23, 92, 196, 0.08);
}

/* 与 Tab 条同高、同条白底内略收阴影，避免「更多」像单独浮块；右侧顶齐白底条 */
.pc_index-more-btn--inbar {
  height: 32px !important;
  padding: 0 10px 0 12px !important;
  margin: 0 0 0 4px !important;
  box-shadow: none !important;
  border-radius: 8px !important;
}

.pc_index-more-btn:hover {
  color: #fff !important;
  background: #175cc4 !important;
  border-color: #175cc4 !important;
}

.pc_index-more-ico {
  font-size: 14px;
}

.index-sub-tabs :deep(.el-tabs) {
  --el-tabs-header-height: 36px;
}

.index-sub-tabs :deep(.el-tabs__header) {
  margin: 0;
}

.index-sub-tabs :deep(.el-tabs__nav-wrap::after),
.index-sub-tabs :deep(.el-tabs__nav-wrap::before) {
  display: none !important;
}

.index-sub-tabs :deep(.el-tabs__nav-scroll) {
  overflow-x: auto;
}

.index-sub-tabs :deep(.el-tabs__nav) {
  border: none;
  gap: 6px;
}

.index-sub-tabs :deep(.el-tabs__item) {
  height: 32px;
  line-height: 32px;
  padding: 0 12px !important;
  margin: 0 1px;
  border-radius: 8px !important;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  border: none !important;
  transition: background 0.15s ease, color 0.15s ease;
}

.index-sub-tabs :deep(.el-tabs__item:hover) {
  color: #175cc4;
  background: rgba(23, 92, 196, 0.08);
}

.index-sub-tabs :deep(.el-tabs__item.is-active) {
  color: #fff !important;
  background: linear-gradient(135deg, #175cc4 0%, #2d7fd8 100%) !important;
  font-weight: 600;
}

.index-sub-tabs :deep(.el-tabs__active-bar) {
  display: none !important;
}

.el-main{
  --el-main-padding: 0px;
}

.pc_index-grid-wrap {
  position: relative;
  /* 约等于单行卡片高度，加载时略防抖跳，又不在一级之间留出大块空白 */
  min-height: clamp(200px, 22vw, 260px);
}

.index-global-empty {
  padding: 40px 16px 24px;
}

.pc_index-sub-empty {
  padding: 28px 8px 20px;
}

.pc_index-empty-section {
  padding-bottom: 8px;
}

.suspended-button{
    --el-backtop-bg-color: var(--el-bg-color-overlay);
    --el-backtop-text-color: var(--el-color-primary);
    --el-backtop-hover-bg-color: var(--el-border-color-extra-light);
    position: fixed;
    background-color: var(--el-backtop-bg-color);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: var(--el-backtop-text-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: var(--el-box-shadow-lighter);
    cursor: pointer;
    z-index: 5;
}
</style>
<style scoped>
.h5_container {
  height: calc(100vh - 46px - 30vh); /* 设置容器高度 */
  overflow-y: auto; /* 启用垂直滚动 */
}
.h5_video-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.h5_text-content {
  color: #969799;
  padding-left: 20px;
  padding-right: 20px;
}

.h5_text-content div{
  font-size: 14px; 
  margin-top: 10px;
}

.h5_custom-icon {
  color: #007bff; /* 图标的颜色，可以根据需要调整 */
}

.h5-index-body {
  min-height: 100vh;
  background: linear-gradient(180deg, #f4f8fc 0%, #eef4fb 40%, #fff 100%);
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.h5_index-content {
  margin: 0 auto;
  max-width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 8px;
}

.h5_index-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 40px;
  margin: 6px 0 8px;
}

.h5_index-section-name {
  flex: 1;
  min-width: 0;
  font-weight: 700;
  color: #1e293b;
  font-size: 17px;
  letter-spacing: 0.02em;
  line-height: 1.3;
}

.h5_index-more-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-color: rgba(23, 92, 196, 0.45) !important;
  color: #175cc4 !important;
  font-weight: 600 !important;
}

.h5_index-more-ico {
  font-size: 14px;
  margin-left: 2px;
}

.h5_index-empty-block {
  padding: 12px 0 20px;
}
  
</style>
